import { CellNode, CheckboxNode, DateNode, DropdownElementNode, DropdownGroupNode, FormNode, InvalidNode, LabelNode, PageNode, RadioButtonElementNode, RadioButtonGroupNode, RowNode, SectionNode, TableNode, TextBoxNode, ImageNode, ElementNode } from "..";

export abstract class TemplateNodeVisitor {

    protected visitChildren(node: ElementNode | PageNode | FormNode) {
        node.children.forEach(v => {
            v.accept(this);
        });
    }

    visitFormNode(node: FormNode) {
        this.visitChildren(node);
    }

    visitPageNode(node: PageNode) {
        this.visitChildren(node);
    }

    visitSectionNode(node: SectionNode) {
        this.visitChildren(node);
    }

    visitTableNode(node: TableNode) {
        this.visitChildren(node);
    }

    visitRowNode(node: RowNode) {
        this.visitChildren(node);
    }

    visitCellNode(node: CellNode) {
        this.visitChildren(node);
    }

    visitDropdownGroupNode(node: DropdownGroupNode) {
        this.visitChildren(node);
    }

    visitRadioButtonGroupNode(node: RadioButtonGroupNode) {
        this.visitChildren(node);
    }

    visitDropdownElementNode(node: DropdownElementNode) {
        this.visitChildren(node);
    }

    visitRadioButtonElementNode(node: RadioButtonElementNode) {
        this.visitChildren(node);
    }

    visitLabelNode(node: LabelNode) {
        this.visitChildren(node);
    }

    visitTextBoxNode(node: TextBoxNode) {
        this.visitChildren(node);
    }

    visitCheckboxNode(node: CheckboxNode) {
        this.visitChildren(node);
    }

    visitDateNode(node: DateNode) {
        this.visitChildren(node);
    }

    visitImageNode(node: ImageNode) {
        this.visitChildren(node);
    }

    visitInvalidNode(node: InvalidNode) {
        this.visitChildren(node);
    }
}
